<template>
  <a-modal
    :title="title === '1' ? $t('add') : $t('edit')"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'dictType')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'dictType')" v-decorator="[ 'dictType', validatorRules.dictType]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'dictKey')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'dictKey')" v-decorator="[ 'dictKey', validatorRules.dictKey]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'dictValue')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'dictValue')" v-decorator="[ 'dictValue', validatorRules.dictValue]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'dictSort')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'dictSort')" v-decorator="[ 'sort', validatorRules.sort]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'remark')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'remark')" v-decorator="[ 'remark', validatorRules.remark]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'dictStatus')">
          <a-radio-group
            v-decorator="['status', { initialValue: '0' }]">
<!--            <a-radio value="0">有效</a-radio>-->
<!--            <a-radio value="1">无效</a-radio>-->
            <span v-for="item in this.dictStatuses">
              <a-radio :value=item>{{ $t(I18N_KEY + 'dictStatus_' + item) }}</a-radio>
            </span>
<!--            <a-radio v-for="item in this.dictStatuses">-->
<!--              {{ $t(I18N_KEY + 'dictStatus_' + item.dictValue) }}-->
<!--            </a-radio>-->
          </a-radio-group>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
const I18N_KEY = 'custServiceWorkOrder.';
export default {
  name: "DictModal",
  data () {
    return {
      I18N_KEY,
      title:"操作",
      visible: false,
      dictStatuses: ["0","1"],
      // roleDisabled: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        dictType:{
          rules: [
            { required: true, message: 'Please input dict type!' },
          ]},
        dictKey:{
          rules: [
            { required: true, message: 'Please input dict key!' },
          ]},
        dictValue:{
          rules: [
            { required: true, message: 'Please input dict value!'},
          ]},
        sort:{
          rules: [
            { required: true, message: "Please input dict sort!"},
          ]},
        remark:{
          rules: [
          ]}
      },
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.status != undefined ? '' + this.model.status : '0',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'dictType', 'dictKey', 'dictValue', 'sort','status','remark'))
      });

    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      console.log(88888)
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>